module.exports = __webpack_public_path__ + "img/role4.30cab345.png";